import api from '@/api';

import { API_BASE_URL } from '..';
import { ReportAreasParams, ReportNcmParams } from './Report.types';

const baseUrl = API_BASE_URL;

export async function generateAreasReport(params?: ReportAreasParams) {
  const result = (await api.getReport(
    `${baseUrl}/generate/areas`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateNcmReport(params?: ReportNcmParams) {
  const result = (await api.getReport(
    `${baseUrl}/generate/ncm`,
    params,
  )) as unknown;

  return result as BlobPart;
}
